
























































































import { Ability } from '@casl/ability'
import { Button, Popover, Tooltip } from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'

import Booking from '@/models/booking'

import getAbilitiesFor from '@/abilities/booking/abilities'

@Component({
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover,
    [Tooltip.name]: Tooltip,
  },
})
export default class BookingPayments extends Vue {
  @Prop() booking!: Booking
  @Prop() bookingLoaded!: boolean

  get ability(): Ability {
    return getAbilitiesFor(this.booking)
  }

  openPaymentModal() {
    this.$emit('on-payment-modal-open')
  }
}
